/**
 * Created by haluk on 4/17/17.
 */

import shared from './shared';

export default {
  shared
}
